<div class="bg-white dark:bg-gray-800 rounded-2xl shadow-xl h-full md:w-200 flex flex-col overflow-hidden w-full">
    
    <!-- Header (No Flex Shrink) -->
    <div class="p-6 border-b dark:border-gray-700 flex-shrink-0">
        <div class="flex justify-between items-start">
            <div>
                <h2 class="text-2xl font-bold text-gray-800 dark:text-gray-100">Checklist Item Library</h2>
                <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">Manage and select reusable checklist items.</p>
            </div>
            <button mat-icon-button mat-dialog-close class="mt-[-8px] mr-[-8px]">
                <mat-icon svgIcon="tabler_outline:x"></mat-icon>
            </button>
        </div>

        <!-- Search & Add -->
        <div class="mt-4 grid grid-cols-1  gap-4 items-start">
            <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>Search library</mat-label>
                <mat-icon matPrefix svgIcon="tabler_outline:search" class="mr-2"></mat-icon>
                <input matInput [formControl]="searchCtrl">
            </mat-form-field>
            <mat-form-field *ngIf="hasCreateChecklist" class="w-full" subscriptSizing="dynamic">
                <mat-label>Quick Add New Item</mat-label>
                <input matInput [formControl]="quickAddCtrl" (keydown.enter)="quickAddItem()">
                <button mat-flat-button matSuffix color="primary" (click)="quickAddItem()" [disabled]="quickAddCtrl.invalid || isProcessing">
                    <mat-spinner *ngIf="isProcessing" diameter="20"></mat-spinner>
                    <span *ngIf="!isProcessing">Add</span>
                </button>
            </mat-form-field>
        </div>
    </div>

    <!-- Body with Scrollable List (Flex Grow) -->
    <div class="p-6 flex-grow overflow-y-auto relative">
        <div *ngIf="isLoading" class="absolute inset-0 flex items-center justify-center bg-white dark:bg-gray-800 bg-opacity-75 dark:bg-opacity-75 z-10">
            <mat-spinner></mat-spinner>
        </div>

         <!-- Select All -->
         <div *ngIf="mode === 'SELECT' && templates.length > 0" class="px-1 pb-2 mb-3 border-b border-gray-200 dark:border-gray-700">
            <mat-checkbox [checked]="isAllSelected()" (change)="toggleSelectAll($event)">
                <span class="text-sm font-medium text-gray-600 dark:text-gray-300">Select All Visible</span>
            </mat-checkbox>
        </div>

        <!-- List -->
        <div *ngIf="!isLoading && templates.length > 0" class="space-y-3">
            <div *ngFor="let template of templates"
                 (click)="toggleSelection(template)"
                 class="flex items-center p-3 bg-white dark:bg-gray-700/50 border dark:border-gray-600 rounded-lg shadow-sm transition-all duration-200"
                 [ngClass]="{
                    'cursor-pointer hover:shadow-md hover:border-blue-400 dark:hover:border-blue-500': mode === 'SELECT' && !isDisabled(template),
                    'border-blue-500 dark:border-blue-400 ring-1 ring-blue-500 dark:ring-blue-400': selection.has(template._id),
                    'opacity-60 bg-gray-50 dark:bg-gray-700 cursor-not-allowed': isDisabled(template)
                 }">
                <mat-checkbox *ngIf="mode === 'SELECT'"
                              class="mr-4"
                              [checked]="selection.has(template._id) || isDisabled(template)"
                              [disabled]="isDisabled(template)"
                              (click)="$event.stopPropagation()"
                              (change)="toggleSelection(template)">
                </mat-checkbox>
                <span class="flex-grow text-gray-800 dark:text-gray-200 pl-3">{{ template.name }}</span>
                <button *ngIf="mode === 'BROWSE' && hasDeleteChecklist"
                        mat-icon-button color="warn"
                        (click)="deleteItem(template, $event)">
                    <mat-icon svgIcon="tabler_outline:trash"></mat-icon>
                </button>
            </div>
        </div>

        <!-- Empty State -->
        <div *ngIf="!isLoading && templates.length === 0" class="text-center py-12 text-gray-500 dark:text-gray-400">
            No items found in the library.
        </div>
    </div>

    <!-- Footer (No Flex Shrink) -->
    <div class="p-4 bg-gray-50 dark:bg-gray-900/50 border-t dark:border-gray-700 flex-shrink-0 flex justify-between items-center">
        <div>
            <span *ngIf="mode === 'SELECT'" class="text-sm font-medium text-gray-600 dark:text-gray-300">
                {{ selection.size }} item(s) selected
            </span>
        </div>
        <div>
            <button mat-stroked-button mat-dialog-close>Cancel</button>
            <button *ngIf="mode === 'SELECT'"
                    mat-flat-button color="primary"
                    class="ml-2"
                    [disabled]="selection.size === 0"
                    (click)="addSelectedItems()">
                Add Selected Items
            </button>
        </div>
    </div>
</div>